import dayjs from 'dayjs';

const locales = {
	az: () => import('dayjs/locale/az'),
	de: () => import('dayjs/locale/de'),
	tr: () => import('dayjs/locale/tr'),
	en: () => import('dayjs/locale/en'),
	ru: () => import('dayjs/locale/ru'),
	'zh-tw': () => import('dayjs/locale/zh-tw')
};

function loadDayJsLocale(language: string) {
	if (language === 'zh') {
		language = 'zh-tw';
	}
	locales[language]().then(() => dayjs.locale(language));
}

export { loadDayJsLocale };
